import React from "react";
import Sidebar from "../../components/commons/Sidebar";
import DashboardC from "../../components/admin/dashboard";

const Dashboard = () => (
  <div className="flex flex-col md:flex-row min-h-screen bg-gray-900">
    <Sidebar />
    <div className="flex-1 overflow-auto">
      <DashboardC />
    </div>
  </div>
);

export default Dashboard;
